import React, {Component} from 'react';
import {DownOutlined, FolderOutlined} from '@ant-design/icons';
import {Tree} from 'antd';
import {folderGetByLevelByUser} from "../requests/Folder";
import {updateFolder} from '../../action/action';
import {connect} from 'react-redux';

const {TreeNode} = Tree;

const iconFolderPlus = <FolderOutlined/>;

class FolderTree extends Component {
    tree = {};

    constructor(props) {
        super(props);
        this.state = {
            tree: this.tree,
            isLoading: true
        };
        this.dataToTree = this.dataToTree.bind(this);
    }

    onSelect = (selectedKeys) => {
        this.searchTree({children: this.state.tree}, selectedKeys[0], (node) => {
            this.props.onChange(node, this.state.tree);
        });
    };

    searchTree = (element, matchingId, callback) => {
        if (element._id === matchingId) {
            callback(element);
            return element;
        } else if (element.children != null) {
            let i;
            let result = null;
            for (i = 0; result == null && i < element.children.length; i++) {
                result = this.searchTree(element.children[i], matchingId, callback);
            }
            return result;
        }
        return null;
    }

    async componentDidMount() {
        folderGetByLevelByUser(this.props.userName, 0, (response) => {
            this.props.updateFolder(response);
            this.setState({tree: response, isLoading: false});
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.isRefresh) {
            if (prevProps.selectedFolderID === this.props.selectedFolderID && prevProps.isRefresh) {
                return;
            }
            this.componentDidMount().then(() => {
                if (typeof this.props.updateAction === "function") {
                    this.props.updateAction(false);
                }
            });
        }
    }

    dataToTree(data) {
        return (data.map((node) => {
            if (node.children !== undefined && node.children.length > 0) {
                return (<TreeNode icon={iconFolderPlus} title={node.name}
                                  key={node._id}> {this.dataToTree(node.children)} </TreeNode>);
            } else return (<TreeNode icon={iconFolderPlus} title={node.name} key={node._id} isLeaf/>);
        }));
    }

    render() {

        const {tree, isLoading} = this.state;
        if (isLoading) {
            return <p>Loading...</p>;
        }
            return (
                <Tree key="Key_selectedFolderID"
                      showIcon
                      defaultExpandAll
                      onSelect={this.onSelect}
                      switcherIcon={<DownOutlined/>}
                      defaultSelectedKeys={[this.props.selectedFolderID]}
                >
                    {this.dataToTree(tree)}
                </Tree>
            );


    }
}

export default connect(undefined, {updateFolder})(FolderTree);